module.exports = __webpack_public_path__ + "static/dashboardBanner-6f6043c39fe744b0d772b6ca688d5008.png";